'use strict'

var conversionTracking = require('../conversionTracking/conversionTracking.js');

module.exports = (function () {
    /**
    * @ngdoc method
    * @name simplePopup
    * @description Initializes simple popups
    **/

    // Needs only be initialized once per page
    var initializeSimplePopups = function (selector, optionOverrides) {

        var defaultOptions = {
            maxWidth: 923,
            enableConversionTracking: false
        };
        optionOverrides = optionOverrides || {};
        var options = $.extend({}, defaultOptions, optionOverrides);

        var $cta = $(selector);
        if ($cta.length > 0) {
            $cta.fancybox({
                padding: [0],
                fitToView: true,
                scrolling: 'no',
                maxWidth: options.maxWidth,
                autoSize: true,
                autoResize: true,
                tpl: {
                    closeBtn: '<a title="close" class="dialog-close" href="javascript:;"></a>'
                },
                closeClick: false,
                openEffect: 'none',
                closeEffect: 'none',
                afterLoad: function (context, contextAfter) {
                    if (options.enableConversionTracking) {
                        var $form = $(context.href + ' form');
                        if ($form && $form.length > 0) {
                            conversionTracking.pushFormEvent($form, 'popup opened');
                        }
                    }
                },
                afterClose: function (context, contextAfter) {
                    
                    if (options.enableConversionTracking) {
                        var $form = $(context.href + ' form');
                        if ($form && $form.length > 0) {
                            // For an async form, the form will be gone after submit and we will not fire this event.
                            // In that case, it is not as important to track "popup closed"
                            conversionTracking.pushFormEvent($form, 'popup closed');
                        }
                    }
                }
            });
        }
    };

    

    // Return an object exposing the public items
    return {
        initialize: initializeSimplePopups
    };

}())